import { MAX_DISPLAY_NAME_LENGTH } from "./validateDisplayName";

const key = (name) => (name || "").trim().replace(/\s+/g, " ").toLowerCase();

/**
 * The name a joiner gets in a room. A free name is kept as typed; a taken one
 * becomes "Semi 2", "Semi 3", ... so two Semis can play instead of the second
 * being turned away. Compared ignoring case and extra spaces, and the suffix
 * always fits inside MAX_DISPLAY_NAME_LENGTH.
 */
export function uniquePlayerName(rawName, players = []) {
  const name = (rawName || "").trim();
  const taken = new Set((players || []).map((p) => key(p.name)));
  if (!taken.has(key(name))) return name;

  // "Semi 2" colliding should move on to "Semi 3", not become "Semi 2 2".
  const base = name.replace(/\s+\d+$/, "") || name;
  for (let n = 2; ; n += 1) {
    const suffix = ` ${n}`;
    const candidate = base.slice(0, MAX_DISPLAY_NAME_LENGTH - suffix.length).trimEnd() + suffix;
    if (!taken.has(key(candidate))) return candidate;
  }
}
